import React from 'react';
import PropTypes from 'prop-types';

import { InfoWindow } from 'components/core/GoogleMap';
import { NewFacilityCard } from 'components/facility/FacilityCard';

export default function SearchInfoWindow({
	actions,
	facility,
	baseUrl,
	facilitySelected,
	handleFacilityCardVisible,
	handleFacilitySelected,
	handleFacilityDeselected,
	handlePinDeselected,
	location,
	searchType,
	searchParams,
	cloudfrontUrl,
	...rest
}) {
	const infoLocation = facility.location;
	const content = (
		<NewFacilityCard
			facility={facility}
			baseUrl={baseUrl}
			cloudfrontUrl={cloudfrontUrl}
			facilitySelected={facilitySelected}
			getFacilityCardPhoneNumber={() =>
				actions.getFacilityCardPhoneNumber(
					location.city,
					location.state,
					facility.id,
				)
			}
			handleFacilitySelected={handleFacilitySelected}
			handleFacilityDeselected={handleFacilityDeselected}
			handlePinDeselected={handlePinDeselected}
			miniCard
			onVisible={handleFacilityCardVisible}
			storageType={searchType}
			searchParams={searchParams}
		/>
	);

	return (
		<InfoWindow
			{...rest}
			location={infoLocation}
			content={content}
		/>
	);
}

SearchInfoWindow.propTypes = {
	actions: PropTypes.shape({
		getFacilityCardPhoneNumber: PropTypes.func,
	}),
	facility: PropTypes.shape({
		location: PropTypes.object,
		id: PropTypes.number,
	}).isRequired,
	baseUrl: PropTypes.string,
	facilitySelected: PropTypes.number,
	handleFacilityCardVisible: PropTypes.func,
	handleFacilitySelected: PropTypes.func,
	handleFacilityDeselected: PropTypes.func,
	handlePinDeselected: PropTypes.func,
	location: PropTypes.shape({
		city: PropTypes.string,
		state: PropTypes.string,
	}),
	searchType: PropTypes.string,
	searchParams: PropTypes.object,
	cloudfrontUrl: PropTypes.string,
};
